
import { TypeAnimation } from 'react-type-animation';

import { SearchWrapper } from '@share/components';

import { useSelector } from 'react-redux';
import { getPreferenceFileUrlFromAccount, RootState } from '@share/utils';
import { BACKGROUND_PHOTO_FIELD_KEY, BACKGROUND_PHOTO_MOBILE_FIELD_KEY } from '@share/common-types';
import { IAccount } from '@share/common-types';
import { DEFAULT_MEDIA_POINT } from '@share/constants';

import { SearchAshevillePlayHeaderBottom } from '../search-ashevilleplay-header-bottom/component';

import './style.scss';

interface IProps {
  isAfterSearchLoad: boolean;
  
  onClick: (actionId: string) => void;
}

export function SearchAshevillePlayHeader({ isAfterSearchLoad, onClick }: IProps) {

  const isMobile = document.body.offsetWidth <= DEFAULT_MEDIA_POINT;

  const loginStore = useSelector((state: RootState) => state.loginStore);
  
  const { account } = loginStore;

  const backgroundImage = getPreferenceFileUrlFromAccount(account as IAccount, BACKGROUND_PHOTO_FIELD_KEY);
  const backgroundImageMobile = getPreferenceFileUrlFromAccount(account as IAccount, BACKGROUND_PHOTO_MOBILE_FIELD_KEY);

  const logoImage = backgroundImage ? 
                        (isMobile && backgroundImageMobile) ? 
                            backgroundImageMobile : 
                            backgroundImage : 
                        null;

  const style: any = { backgroundImage: isAfterSearchLoad ? null : `url(${logoImage})` };

  return (
    <div className={`search-asheville-play-header${!isAfterSearchLoad ? ' home-search-load' : ''}`} style={style}>
      {!isAfterSearchLoad && 
        <div className="overlay-brand"></div>}
        
      {!isAfterSearchLoad && 
        <>
          <span className="search-asheville-play-header__title">Your Asheville <TypeAnimation sequence={[
              'VACATION',
              1000,
              'JOURNEY',
              1000,
              'FUN',
              1000,
              'ADVENTURE',
              1000,
              'STORY',
              1000,
              'ESCAPE',
              1000,
            ]}
            repeat={Infinity}
            wrapper="span"
            style={{ fontSize: isMobile ? '30px' : '45px', fontWeight: '700', color: '#F4E285' }}
            speed={20}
          /> starts here.</span>
          <p className="search-asheville-play-header__subtitle">Explore top hotels & epic tours — handpicked for your perfect getaway</p>
        </>}

      <SearchWrapper />

      {!isAfterSearchLoad && 
        <SearchAshevillePlayHeaderBottom onClick={onClick} />}
    </div>
  );
}
